module.exports = __webpack_public_path__ + "8e15de47536bf78b2565ea5d99fa6b88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2_2023_chart.png
// module id = 1739
// module chunks = 0